import { Button, VStack } from '@chakra-ui/react';
import { zodResolver } from '@hookform/resolvers/zod';
import { InputText } from 'components/Atomos/Form/Elements/InputText';
import { InputTextMask } from 'components/Atomos/Form/Elements/InputTextMask';
import { LoginCredentials, loginCredentialsSchema } from 'models/auth.model';
import { FormComponentProps } from 'models/loginForm';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import masks from 'utils/masks/masks';

type LoginFormProps = FormComponentProps<LoginCredentials>;

const LoginForm = ({
    onSuccess,
    onFailed
}: LoginFormProps) => {
    const { register, control, handleSubmit, formState: { errors } } = useForm<LoginCredentials>({
        resolver: zodResolver(loginCredentialsSchema)
    });
    const [isLoggingIn, setIsLoggingIn] = useState(false);
    const handleLoginClick = async (data: LoginCredentials) => {
        try {
            setIsLoggingIn(true);
            await onSuccess(data);
        } catch (err) {
            onFailed?.(err);
        } finally {
            setIsLoggingIn(false);
        }
    }

    return (
        <VStack as="form" onSubmit={handleSubmit(handleLoginClick)}>
            <InputTextMask
                mask={masks.BRL_CPF}
                name="cpf"
                label="CPF"
                control={control}
                error={errors.cpf}
                my={3}
            />
            <InputText
                type="password"
                name="password"
                label="Senha"
                register={register}
                error={errors.password}
                my={3}
            />
            <Button colorScheme="main" type="submit" my={3} isFullWidth isLoading={isLoggingIn}>Entrar</Button>
        </VStack>
    )
}

export default LoginForm